// src/services/api.js
import axios from "axios";

// Create an Axios instance
const api = axios.create({
  baseURL: "/api", // "http://localhost:8000/api",
  timeout: 3500000, // Maximum wait time for backend response
});

// Request interceptor: add access token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle token refresh on 401 / 403
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip token refresh for the refresh endpoint itself
    if (
      originalRequest.url !== "/api-token-refresh" &&
      (error.response?.status === 401 || error.response?.status === 403)
    ) {
      try {
        const refreshToken = localStorage.getItem("REFRESH_TOKEN");
        if (!refreshToken) throw new Error("No refresh token");

        const refreshResponse = await api.post("/api-token-refresh", {
          refresh: refreshToken,
        });

        if (refreshResponse.status === 200) {
          // Update access token in localStorage
          localStorage.setItem("ACCESS_TOKEN", refreshResponse.data.access);

          // Retry the original request with new token
          originalRequest.headers["Authorization"] =
            "Bearer " + refreshResponse.data.access;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.log(
          "Refresh token expired or invalid. Redirecting to login..."
        );

        // Clear tokens and redirect to login
        localStorage.setItem("connected", "false");
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");

        // Use react-router if possible, otherwise fallback to window.location
        window.location.href = "/ConnectionPopUp";

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export { api };
